import { CLIENT_AUTHENTICATION_SERVICE, ClientAuthenticationService } from "@cervval.js/client-auth/src/clientAuthentication.service";
import { LoginData, User } from "@cervval.js/common-auth/src/loginData.model";
import { PermissionString } from "@cervval.js/common-permissions/src/dtos.permissions";
import { AbstractPermissionService } from "@cervval.js/common-permissions/src/services/abstract.permission.service";
import { PERMISSION_SERVICE } from "@cervval.js/common-permissions/src/services/permission.service";
import { Injectable } from "@cervval.js/common/src/dependencies/injectable";
import { Injected } from "@cervval.js/common/src/dependencies/injected";
import { ClientPermissionService } from "./client.permission.service";


@Injectable(PERMISSION_SERVICE)
export abstract class AbstractClientPermissionService<CustomLoginData extends LoginData<User>, PermissionContext, PS extends PermissionString = PermissionString>
    extends AbstractPermissionService<CustomLoginData, PermissionContext, PS>
    implements ClientPermissionService<CustomLoginData, PermissionContext, PS> {

    @Injected(CLIENT_AUTHENTICATION_SERVICE)
    public readonly clientAuthService!: ClientAuthenticationService<User, CustomLoginData>;

    /**
     * build permission context from application environment (usually from a selection service)
     */
    public getPermissionContext?: () => PermissionContext;

    /** @inheritdoc */
    public hasClientPermission(permissions: PS | PS[], permissionContext?: PermissionContext, matchAllPermission?: boolean): boolean {
        const context = permissionContext ?? this.getPermissionContext?.();
        return this.hasPermission(this.clientAuthService.getLoginData(), permissions, context, matchAllPermission);
    }
}